import { API, authClient } from '../index'

// Get all projects
export const getAllProjects = () => {
    return authClient().get(`${API}/project/`)
}

// Get project by id
export const getProjectById = (id) => {
    return authClient().get(`${API}/project/${id}`)
}

// Create project
export const postProject = async (project) => {
    return authClient().post(`${API}/project/`, project)
}

// Update text
export const updateProject = (id, project) => {
    return authClient().put(`${API}/project/${id}`, project)
}
// Change status project
export const changeStatusProjectStatus = async (id, active) => {
    return authClient().put(`${API}/project/change-status/${id}`, { active });
};

// Delete project
export const deleteProject = (id) => {
    return authClient().delete(`${API}/project/${id}`)
}